import initApollo from "~/utils/apollo";

export default defineNuxtPlugin(() => {
  initApollo();
});
